/**
 * Tile Configuration
 * Grid layout and texture paths for tiled Earth textures
 */

export const TILE_GRID = {
  LOD_1: {
    columns: 11,
    rows: 6,
    tileSize: 512,
    totalTiles: 66,
    sourceResolution: '8192x4096',
    folder: 'LOD_1',
  },
  LOD_2: {
    columns: 11,
    rows: 6,
    tileSize: 256,
    totalTiles: 66,
    sourceResolution: '8192x4096',
    folder: 'LOD_2',
  },
  LOD_3: {
    columns: 11,
    rows: 6,
    tileSize: 128,
    totalTiles: 66,
    sourceResolution: '8192x4096',
    folder: 'LOD_3',
  },
}

/**
 * Generate tile paths for a given quality level and texture type
 * @param {string} quality - Quality level (LOD_0, LOD_1, etc)
 * @param {string} type - Texture type: 'diffuse' or 'normal'
 * @returns {Array<string>} Array of texture paths
 */
export function getTilePaths(quality = 'LOD_3', type = 'diffuse') {
  const config = TILE_GRID[quality]
  if (!config) {
    console.warn(`Unknown quality level: ${quality}, defaulting to LOD_3`)
    return getTilePaths('LOD_3', type)
  }

  const folder = config.folder || quality
  const extension = (type === 'normal' || type === 'specular') ? 'png' : 'webp'
  const paths = []
  for (let row = 0; row < config.rows; row++) {
    for (let col = 0; col < config.columns; col++) {
      paths.push(`/textures/earth/${type}/${folder}/tile_${col}_${row}.${extension}`)
    }
  }

  return paths
}

/**
 * Get tile path for a specific row and column
 * @param {number} col - Column index
 * @param {number} row - Row index  
 * @param {string} quality - Quality level
 * @param {string} type - Texture type: 'diffuse' or 'normal'
 * @returns {string} Texture path
 */
export function getTilePath(col, row, quality = 'LOD_3', type = 'diffuse') {
  const config = TILE_GRID[quality]
  const folder = config?.folder || quality
  const extension = (type === 'normal' || type === 'specular') ? 'png' : 'webp'
  return `/textures/earth/${type}/${folder}/tile_${col}_${row}.${extension}`
}

/**
 * Configuration for fallback single texture
 * When tiles aren't available or for distant viewing
 */
export const FALLBACK_TEXTURE = {
  path: '/textures/earth/fallback/earth_2k.webp',
  resolution: 2048,
}
